import Form from '../../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../../utils/analytics-helper';

export default class Login {
    constructor(parent) {
        this.parent = parent;
        this.modal = this.parent.parent;
        this.util = this.modal.parent;
        this.el = parent.el.querySelector('.login-tab');
        this.tabLink = parent.el.querySelector('.login-tab-link');
        this.form = new Form(this.el.querySelector('.login-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.forgotPassword = this.el.querySelector('.forgot-password');
        this.username = this.el.querySelector('[name="username"]');
        this.lockedMessage = this.form.el.dataset.lockedMessage;
        this.bind();
    }

    bind() {
        this.tabLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.modal.show({ view: 'login', tab: 'login' });
            this.modal.el.querySelector('input[name="username"]').focus({ preventScroll: true });
        });
        this.forgotPassword.addEventListener('click', (e) => {
            e.preventDefault();
            this.passwordSendOtp();
        });
    }

    onSuccess(result) {
        if (result.register) {
            this.modal.show({ view: 'partial-register' });
        } else {
            this.modal.hide();
            this.util.onLogin();
        }

        this.analyticsPush(result);
    }

    onError(result) {
        if (result?.locked) {
            this.passwordSendOtp(this.lockedMessage);
            this.form.hideError();
        } else {
            this.form.showError();
        }

        this.analyticsPush(result);
    }

    passwordSendOtp(message) {
        const passwordSendOTPView = this.modal.views['password-send-otp'];
        const passwordSendOTPEmail = passwordSendOTPView.el.querySelector('[name="email"]');
        if (passwordSendOTPEmail && this.username) {
            passwordSendOTPEmail.value = this.username.value;
        }
        this.modal.show({ view: 'password-send-otp', message });
    }

    show() {
        this.el.classList.remove('hide');
        this.tabLink.classList.add('active');
        this.modal.el.querySelector('input[name="username"]').focus({ preventScroll: true });
    }

    hide() {
        this.el.classList.add('hide');
        this.tabLink.classList.remove('active');
    }

    analyticsPush(result) {
        this.loginStatus = result.success ? 'Logged In:Success' : 'Logged In:Failed';
        const customerId = window.HONDA.MyAccount2.id();

        AnalyticsHelper.push({
            event: 'my_account',
            eventCategory: 'my account',
            eventAction: 'Login Entry',
            eventLabel: `${dataLayer[0].productCategory}|My account|Log In|internal|#`,
            actionType: 'Login Entry',
            businessUnit: dataLayer[0].productCategory,
            moduleName: 'My account',
            clickText: 'Log In',
            clickType: 'internal',
            destinationURL: '#',
        });

        AnalyticsHelper.push({
            event: 'my_account',
            eventCategory: 'my account',
            eventAction: this.loginStatus,
            eventLabel: `${dataLayer[0].productCategory }|My account|Log In|internal|#`,
            actionType: this.loginStatus,
            businessUnit: dataLayer[0].productCategory,
            moduleName: 'My account',
            clickText: 'Log In',
            clickType: 'internal',
            destinationURL: '',
            accountId: customerId,
        });
    }
}
